



import React, { FC, useEffect } from 'react'

interface ModalProps {
    modalName: string;
    rootEle: string , 
    parentEle : string , 
    childEle : string
}
const ModalOnOff: FC<ModalProps> = ({ modalName , rootEle , parentEle , childEle  }) => {

    //const [height, setHeight] = useState('');

    useEffect(() => {
        const merchantElement = document.getElementById(rootEle);
        const modalElement = document.getElementsByClassName(parentEle) as HTMLCollectionOf<HTMLElement>;
        const editElement = document.getElementsByClassName(childEle) as HTMLCollectionOf<HTMLElement>;
        /* const merchantHeight = merchantElement?.clientHeight;
        const modalHeight = modalElement[0]?.clientHeight; */



        if (merchantElement) {
            if (modalName ==="showEdit" || modalName ==="showCreate" || modalName === "showAddCurrency" || 
                modalName==="showNewOutlet" || modalName==="showNewUser" ||modalName==="EditOutlet" || modalName==="EditUser" || modalName==="addTerminal" ) {
                merchantElement.style.height = `100vh`;
                merchantElement.style.overflow = "hidden";
                if(modalName==="showAddCurrency"||modalName==="showNewUser"||modalName==="showNewOutlet" || modalName==="addTerminal")
                {modalElement[0].style.height="100vh"}
                if(modalName==="EditUser"||modalName==="EditOutlet"){
                    modalElement[0].style.height="100%"
                }
                editElement[0] ? editElement[0].style.height = "auto" : "auto"
            }
        }
        return () => {
            if (merchantElement) {
                merchantElement.style.height = "auto";
                merchantElement.style.overflow = "auto"
            }
        }

    }, [modalName])

    
    return (
        <>

        </>
    )
}
export default ModalOnOff; 